import React from 'react';
import { Button } from '@antonpodolsky/design-system/controls/button/button';
import { BROWSERS, Browser } from './addon-browsers';

interface Props {
  browser: Browser;
}

export const AddonButton = ({ browser }: Props) => {
  const { name, storeUrl, icon } = BROWSERS[browser];

  return (
    <Button
      variant="accent"
      image={icon}
      href={storeUrl}
      title={`Get Exify for ${name}`}
      external
    >
      Add to {name}
    </Button>
  );
};
